module.exports = __webpack_public_path__ + "img/WAREHOUSING.4769224a.svg";